

function nameCheck(name) {
    let engName = /^[a-zA-Z'\s-]+$/;
    let hebName = /^[\u0590-\u05FF'\s-]+$/;
    if(name.length < 2 || name.length > 30) {
        return false;
    } else {
        if(!engName.test(name)){
            return hebName.test(name);
        } else {
            return true;
        }
    }
}


function numbersCheck(number, min_valid_num, max_valid_num) {
    if(!isNaN(number)){
        let numKidsInt = parseInt(number);
        return numKidsInt >= min_valid_num && numKidsInt <= max_valid_num;
    }else{
        return false;
    }
}


function validateForm(errors) {
    let valid = true;
    Object.values(errors).forEach(
      // if we have an error string set valid to false
      (val) => val.length > 0 && (valid = false)
    );
    return valid;
  }
  
  
function phoneCheck(phoneNumber) {
    const regex =/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    return regex.test(phoneNumber)
}



exports.nameCheck = nameCheck;
exports.numbersCheck = numbersCheck;
exports.validateForm = validateForm;
exports.phoneCheck = phoneCheck;